import { useState } from "react";
import RightTimeApi from "@/API"; // Ensure you import RightTimeApi if it's used
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import { toast } from "react-toastify";
import Enums from "@/enums";
import { apiMessage } from "@/utils/apiMessage";

export default function TestRolePermissionsTable(props) {

  const canEditRoles = props.adminPerms?.includes(Enums.ROLE_PERMS.EditRoles)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);

  if (!props.role || !props.role.id) return null;

  const sortedTestTypes = [...(props.data.testTypes ?? [])].sort((a, b) =>
    a.companyTestType.name.localeCompare(b.companyTestType.name)
  );

  async function toggleTestPermAsync(companyTestTypeId, testTypeId, roleId, access) {
    let callData = {
      companyTestTypeId: companyTestTypeId,
      testTypeId: testTypeId,
      roleId: roleId,
      type: access,
    };
    const resp = await RightTimeApi.putAsync("/ToggleTestRolePermission", callData);
    const successMsg = apiMessage(resp);
    if (resp && resp.ok && successMsg)
      toast.success(successMsg);
    props.updateData();
  }

  return (
    <div className="tableWrapper factTable scrollable roleTestAccessTable" style={{ maxHeight: "600px" }}>
      <table className="formFields">
        <caption>
          <span className="title">Role / Test Access</span>
        </caption>
        <thead>
          <tr>
            <th>Test</th>
            <th>Perms</th>
          </tr>
        </thead>
        <tbody>
          {sortedTestTypes.map((tt) => {
              {/* debugger; */ }
              //console.log(['testStatuses', data.testStatuses]);
              return (
                <tr
                  key={"tt" + tt.companyTestType.id}
                  className={tt.companyTestType.active === false ? "inactive" : undefined}
                >
                  <td>{tt.companyTestType.name}</td>

                  <td className="left" key={"role" + props.role.id}>
                    <div
                      className="actionBlock"
                      onClick={() => {
                        if (canEditRoles) {
                          toggleTestPermAsync(
                            tt.companyTestType.id,
                            tt.companyTestType.testTypeId,
                            props.role.id,
                            "view"
                          );
                        }
                      }}
                    >
                      {props.data.roleTests.find(
                        (roleTest) =>
                          roleTest.companyTestTypeId === tt.companyTestType.id &&
                          roleTest.roleId === props.role.id &&
                          roleTest.canView
                      ) ? (
                        <MdCheckBox
                          className={`checkbox checked actionIcon${canEditRoles ? "" : " disabled"}`}
                          data-id={tt.companyTestType.id}
                        />
                      ) : (
                        <MdCheckBoxOutlineBlank
                          className={`checkbox unchecked actionIcon${canEditRoles ? "" : " disabled"}`}
                          data-id={tt.companyTestType.id}
                        />
                      )}
                      <span className="actionText">View</span>
                    </div>
                    <div
                      className="actionBlock"
                      onClick={() => {
                        if (canEditRoles) {
                          toggleTestPermAsync(
                            tt.companyTestType.id,
                            tt.companyTestType.testTypeId,
                            props.role.id,
                            "create"
                          );
                        }
                      }}
                    >
                      {props.data.roleTests.find(
                        (roleTest) =>
                          roleTest.companyTestTypeId === tt.companyTestType.id &&
                          roleTest.roleId === props.role.id &&
                          roleTest.canCreate
                      ) ? (
                        <MdCheckBox
                          className={`checkbox checked actionIcon${canEditRoles ? "" : " disabled"}`}
                          data-id={tt.companyTestType.id}
                        />
                      ) : (
                        <MdCheckBoxOutlineBlank
                          className={`checkbox unchecked actionIcon${canEditRoles ? "" : " disabled"}`}
                          data-id={tt.companyTestType.id}
                        />
                      )}
                      <span className="actionText">Create</span>
                    </div>
                    <div
                      className="actionBlock"
                      onClick={() => {
                        if (canEditRoles) {
                          toggleTestPermAsync(
                            tt.companyTestType.id,
                            tt.companyTestType.testTypeId,
                            props.role.id,
                            "take"
                          );
                        }
                      }}
                    >
                      {props.data.roleTests.find(
                        (roleTest) =>
                          roleTest.companyTestTypeId === tt.companyTestType.id &&
                          roleTest.roleId === props.role.id &&
                          roleTest.canTake
                      ) ? (
                        <MdCheckBox
                          className={`checkbox checked actionIcon${canEditRoles ? "" : " disabled"}`}
                          data-id={tt.companyTestType.id}
                        />
                      ) : (
                        <MdCheckBoxOutlineBlank
                          className={`checkbox unchecked actionIcon${canEditRoles ? "" : " disabled"}`}
                          data-id={tt.companyTestType.id}
                        />
                      )}
                      <span className="actionText">Take</span>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}

